// src/SettingsScreen.js
import React, { useState, useEffect } from 'react';
import { B } from './constants';
import { GBWordmark } from './components/Logo';
import { useAuth } from './AuthContext';
import Footer from './components/Footer';

const COUNTRIES = [
  { id: 'india', label: '🇮🇳 India' },
  { id: 'uae', label: '🇦🇪 UAE' },
  { id: 'global', label: '🌍 Global' },
];

export default function SettingsScreen({ goScreen }) {
  const { user, logout } = useAuth();
  const [country, setCountry] = useState(() => localStorage.getItem('gb_country') || 'global');
  const [notifications, setNotifications] = useState(() => localStorage.getItem('gb_notifications') !== 'false');

  useEffect(() => {
    localStorage.setItem('gb_country', country);
  }, [country]);

  useEffect(() => {
    localStorage.setItem('gb_notifications', notifications);
  }, [notifications]);

  const handleSignOut = () => {
    logout();
    goScreen('home');
  };

  const memberSince = user?.createdAt 
    ? new Date(user.createdAt).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    : 'N/A';

  return (
    <div style={{ minHeight: '100vh', background: '#0d1117' }}>
      <div style={{ maxWidth: 600, margin: '0 auto', padding: '40px 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <GBWordmark size="md" />
          <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 36, color: 'white', marginTop: 20 }}>Settings</h1>
        </div>

        <div style={{ background: '#1a2332', borderRadius: 16, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)' }}>
          
          {/* Profile Section */}
          <div style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <h2 style={{ fontSize: 13, fontWeight: 700, color: B.mint, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Profile</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ width: 64, height: 64, borderRadius: '50%', background: `linear-gradient(135deg,${B.forest},${B.mint})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 800, color: 'white' }}>
                {user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0,2) || '?'}
              </div>
              <div>
                <p style={{ color: 'white', fontSize: 18, fontWeight: 600 }}>{user?.name || 'User'}</p>
                <p style={{ color: '#888', fontSize: 14 }}>{user?.email || 'email@example.com'}</p>
              </div>
            </div>
          </div>

          {/* Country Selection */}
          <div style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <h2 style={{ fontSize: 13, fontWeight: 700, color: B.mint, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Country / Region</h2>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {COUNTRIES.map((c) => (
                <button
                  key={c.id}
                  onClick={() => setCountry(c.id)}
                  style={{
                    padding: '12px 20px',
                    borderRadius: 10,
                    border: country === c.id ? `2px solid ${B.mint}` : '2px solid rgba(255,255,255,0.1)',
                    background: country === c.id ? 'rgba(78,203,141,0.15)' : 'rgba(255,255,255,0.05)',
                    color: country === c.id ? B.mint : '#aaa',
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {c.label}
                </button>
              ))}
            </div>
          </div>

          {/* Notifications */}
          <div style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <h2 style={{ fontSize: 13, fontWeight: 700, color: B.mint, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Notifications</h2>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <p style={{ color: 'white', fontSize: 15, fontWeight: 600 }}>Push Notifications</p>
                <p style={{ color: '#666', fontSize: 13 }}>Receive updates about your trips</p>
              </div>
              <button
                onClick={() => setNotifications(!notifications)}
                style={{
                  width: 52,
                  height: 28,
                  borderRadius: 14,
                  border: 'none',
                  background: notifications ? B.forest : '#333',
                  cursor: 'pointer',
                  position: 'relative',
                  transition: 'background 0.2s',
                }}
              >
                <div style={{
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  background: 'white',
                  position: 'absolute',
                  top: 3,
                  left: notifications ? 27 : 3,
                  transition: 'left 0.2s',
                }} />
              </button>
            </div>
          </div>

          {/* Account Info */}
          <div style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <h2 style={{ fontSize: 13, fontWeight: 700, color: B.mint, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Account</h2>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#888', fontSize: 14 }}>Member Since</span>
              <span style={{ color: 'white', fontSize: 14, fontWeight: 600 }}>{memberSince}</span>
            </div>
            <div style={{ marginTop: 12 }}>
              <button
                onClick={() => goScreen('subscription')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: 'rgba(78,203,141,0.15)',
                  color: B.mint,
                  border: `1px solid ${B.mint}`,
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                💎 Manage Subscription
              </button>
            </div>
          </div>

          {/* Creator Settings */}
          {user?.isInfluencer && (
            <div style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
              <h2 style={{ fontSize: 13, fontWeight: 700, color: B.mint, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Creator Profile</h2>
              <p style={{ color: '#888', fontSize: 14, marginBottom: 12 }}>
                @{user.username || 'Not set'}
              </p>
              <button
                onClick={() => goScreen('creatorProfile', user.username)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: 'rgba(78,203,141,0.15)',
                  color: B.mint,
                  border: `1px solid ${B.mint}`,
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                👤 View Creator Profile
              </button>
            </div>
          )}

          {/* About */}
          <div style={{ padding: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <h2 style={{ fontSize: 13, fontWeight: 700, color: B.mint, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>About</h2>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#888', fontSize: 14 }}>App Version</span>
              <span style={{ color: 'white', fontSize: 14, fontWeight: 600 }}>1.0.0</span>
            </div>
          </div>

          {/* Sign Out */}
          <div style={{ padding: 24 }}>
            <button
              onClick={handleSignOut}
              style={{
                width: '100%',
                padding: '14px 20px',
                borderRadius: 10,
                border: '1px solid rgba(255,107,122,0.3)',
                background: 'rgba(255,107,122,0.1)',
                color: '#ff6b7a',
                fontSize: 15,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,107,122,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,107,122,0.1)'; }}
            >
              🚪 Sign Out
            </button>
          </div>

        </div>
      </div>
      <Footer goScreen={goScreen} />
    </div>
  );
}
